import {createSelector} from '@ngrx/store';

import {SHIPMENT_SERVICES_FEATURE_KEY, selectShippingModuleState} from '../reducers';

export const selectShipmentServicesState = createSelector(
  selectShippingModuleState,
  (moduleState) => moduleState[SHIPMENT_SERVICES_FEATURE_KEY]
);

export const selectShipmentServicesEntities = createSelector(
  selectShipmentServicesState,
  (state) => state.entities
);

export const selectShipmentServices = createSelector(
  selectShipmentServicesEntities,
  (entities) => Object.values(entities)
);

export const selectErrors = createSelector(
  selectShipmentServicesState,
  (state) => state.errors
);

export const isLoading = createSelector(
  selectShipmentServicesState,
  (state) => state.loading
);

export const isLoaded = createSelector(
  selectShipmentServicesState,
  (state) => state.loaded
);
